// extracted by mini-css-extract-plugin
export default {"filters":"DeviceModelsScreen_filters__2Wnbn"};